const WIDGET_MARKER = '@@AI_WIDGET@@'
const OPEN_TAG_REGEX = /^<ai-widget type="([a-z0-9-]+)">/

function aiWidgetRule (state, startLine, endLine, silent) {
  const start = state.bMarks[startLine] + state.tShift[startLine]
  const max = state.eMarks[startLine]
  const firstLine = state.src.slice(start, max)

  const openMatch = firstLine.match(OPEN_TAG_REGEX)
  if (!openMatch) {
    return false
  }

  let content = firstLine.slice(openMatch[0].length)
  let closeIndex = content.indexOf('</ai-widget>')
  let nextLine = startLine

  while (closeIndex === -1) {
    nextLine += 1
    if (nextLine >= endLine) {
      // Unterminated tag (still streaming in) - bail out and let it
      // fall through as plain text until the closing tag arrives.
      return false
    }
    const lineStart = state.bMarks[nextLine] + state.tShift[nextLine]
    const lineEnd = state.eMarks[nextLine]
    content += '\n' + state.src.slice(lineStart, lineEnd)
    closeIndex = content.indexOf('</ai-widget>')
  }

  if (silent) {
    return true
  }

  const payload = content.slice(0, closeIndex).trim()
  const token = state.push('ai_widget', '', 0)

  token.block = true
  token.meta = { widgetType: openMatch[1], payload }
  token.map = [startLine, nextLine + 1]

  state.line = nextLine + 1
  return true
}

export default function aiWidgetPlugin (md) {
  md.block.ruler.before('paragraph', 'ai_widget', aiWidgetRule)

  md.renderer.rules.ai_widget = (tokens, index) => {
    const { widgetType, payload } = tokens[index].meta
    return `${WIDGET_MARKER}${widgetType}${WIDGET_MARKER}${encodeURIComponent(payload)}${WIDGET_MARKER}`
  }
}

export { WIDGET_MARKER }
